import {
  Box,
  Avatar,
  Stack,
  Typography,
  Rating,
  IconButton,
  Collapse,
} from '@mui/material';
import BaseDialog from '../dialogs/BaseDialog';
import CommentDialog from '../dialogs/CommentDialog';
import { useRef, useState } from 'react';
import useDialog from '@/hooks/dialog';
import ConfirmationModal from '../dialogs/ConfirmationModal';
import {
  useDeleteComment,
  useUpdateCommentByTeacher,
} from '@/hooks/api/comments';
import { enqueueSnackbar } from 'notistack';
import { BiEdit, BiTrash } from 'react-icons/bi';
import { RiShareForwardFill } from 'react-icons/ri';
import ReplyComment from './ReplyComment';
import { TbPin, TbPinFilled } from 'react-icons/tb';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa6';

const CommentCard = ({
  comment,
  id,
  handleRefetchData = null,
  type = 'course',
  pinned = false,
  courseOwner = false,
  blogOwner = false,
  canPin = false,
  maxPinCount = 0,
  hasBuy = false,
}) => {
  const { mutate, isPending } = useDeleteComment();
  const { mutate: mutateUpdate, isPending: isPendingUpdate } =
    useUpdateCommentByTeacher();

  const [open, setOpen] = useState(false);

  const modalRef = useRef(null);
  const { openModal, closeModal } = useDialog(modalRef);

  const confirmModalRef = useRef(null);
  const {
    openModal: openConfirmationModal,
    closeModal: closeConfirmationModal,
  } = useDialog(confirmModalRef);

  const replyModalRef = useRef(null);
  const { openModal: openReplyModal, closeModal: closeReplyModal } =
    useDialog(replyModalRef);

  const handlePinComment = () => {
    if (!canPin) {
      enqueueSnackbar(`حداکثر پیام قابل سنجاق ${maxPinCount} مورد می باشد`, {
        variant: 'error',
      });
      return;
    }
    mutateUpdate(
      {
        commentId: comment._id,
        // courseId: id,
        // hide: true,
        pinToCourse:
          (type === 'course' || type === 'lesson') && !pinned ? true : false,
        pinToProfile: type === 'profile' ? true : false,
        pinToBlog: type === 'blog' && !pinned ? true : false,
        // status: "verified",
      },
      {
        onSuccess: () => {
          enqueueSnackbar(
            pinned ? 'با موفقیت از حالت سنجاق خارج شد' : 'با موفقیت سنجاق شد',
            { variant: 'success' },
          );
        },
      },
    );
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          gap: 1,
          bgcolor: pinned ? 'grey.50' : 'unset',
          p: 1,
          borderRadius: 3,
        }}>
        <Avatar src={comment.user?.avatar} sx={{ width: 72, height: 72 }} />
        <Stack sx={{ mt: 3, width: '100%', gap: 1 }}>
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            <Typography fontWeight={600}>
              {comment.user?.fullName || 'ناشناس'}
            </Typography>
            {type === 'course' || type === 'blog' ? (
              <Rating value={comment.rate || 0} readOnly size="small" />
            ) : (
              ''
            )}
            <Typography variant="caption" color="text.secondary">
              {comment.time}
            </Typography>
            <Box sx={{ ml: 'auto' }}>
              {(courseOwner || blogOwner) && (
                <IconButton
                  size="small"
                  onClick={handlePinComment}
                  color="info">
                  {pinned ? <TbPinFilled /> : <TbPin />}
                </IconButton>
              )}

              {comment.isOwner && (
                <>
                  <IconButton
                    size="small"
                    color="secondary"
                    onClick={openModal}>
                    <BiEdit />
                  </IconButton>
                  <IconButton
                    size="small"
                    color="error"
                    onClick={openConfirmationModal}>
                    <BiTrash />
                  </IconButton>
                </>
              )}
              {hasBuy || courseOwner || blogOwner ? (
                <IconButton size="small" onClick={openReplyModal}>
                  <RiShareForwardFill />
                </IconButton>
              ) : (
                ''
              )}
              {comment.replies?.length ? (
                <IconButton
                  size="small"
                  onClick={() => {
                    setOpen(!open);
                  }}>
                  {open ? <FaChevronUp /> : <FaChevronDown />}
                </IconButton>
              ) : (
                ''
              )}
            </Box>
          </Box>

          <Typography color="text.secondary">{comment.content}</Typography>
        </Stack>
      </Box>

      {comment.replies && comment.replies?.length > 0 && (
        <Collapse in={open}>
          <ReplyComment replies={comment.replies} id={id} />
        </Collapse>
      )}

      <BaseDialog ref={replyModalRef} title="پاسخ به نظر">
        <CommentDialog
          closeModal={closeReplyModal}
          type={type}
          id={id}
          parent={comment._id}
          handleRefetchData={handleRefetchData}
          isReply
        />
      </BaseDialog>

      <BaseDialog ref={modalRef} title="ویرایش نظر">
        <CommentDialog
          closeModal={closeModal}
          type={type}
          id={id}
          commentId={comment._id}
          content={comment.content}
          lastRate={comment.rate}
          isUpdate
        />
      </BaseDialog>

      <BaseDialog ref={confirmModalRef} title="حذف نظر">
        <ConfirmationModal
          openModal={openConfirmationModal}
          closeModal={closeConfirmationModal}
          disabled={isPending}
          data={{
            title: 'حذف نظر',
            content: 'جهت حذف نظر مطمئن هستید؟',
            cancelBtn: 'خیر',
            submitBtn: 'بله، مطمئنم',
            submitFunc: () => {
              mutate(
                { data: { commentId: comment._id } },
                {
                  onSuccess: () => {
                    enqueueSnackbar({
                      variant: 'success',
                      message: 'نظر شما با موفقیت حذف شد',
                    });
                    closeConfirmationModal();
                  },
                },
              );
            },
          }}
        />
      </BaseDialog>
    </>
  );
};

export default CommentCard;
